import { motion } from "framer-motion";
import { productCardData1, productCardData2, productCardData3, productCardData4, productCardData5, productCardData6 } from "../../data/data";

const sections = [
  productCardData1,
  productCardData2,
  productCardData3,
  productCardData4,
  productCardData5,
  productCardData6,
];

export default function ScrollSectionsTimeline() {
  return (
    <div className="relative py-16 bg-gray-50 dark:bg-[#0F172A]">
      <div className="container mx-auto relative">
        {/* Center vertical line */}
        {/* <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-[2px] bg-green-600/30"></div> */}

        <div className="flex flex-col space-y-12">
          {sections?.map((section, idx) => {
            const isLeft = idx % 2 === 0;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative flex flex-col md:flex-row items-center w-full gap-8"
              >
                {/* Connector dot */}
                {/* <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-6 w-6 rounded-full bg-green-600 z-10"></div> */}

                {/* Left: Image or Text depending on index */}
                {isLeft ? (
                  <div className="border rounded-lg p-4 grid md:grid-cols-2 shadow-md">
                    <div className="flex justify-center ">
                      <img
                        src={section.imgSrc}
                        alt={section.title}
                        className="h-[350px] w-[350px] rounded-lg p-4 hover:scale-105 hover:border-primary"
                      />
                    </div>
                    <div className="md:w-full flex flex-col justify-center pr-4">
                      <h4 className="text-lg font-semibold text-slate-800 dark:text-white mb-2">{section.title}</h4>
                      <p className="text-slate-600 dark:text-slate-300 text-base">{section.description}</p>
                    </div>
                  </div>
                ) : (
                  <div className="border rounded-lg p-4 grid md:grid-cols-2 shadow-md">
                    <div className="md:w-full flex flex-col justify-center pl-4">
                      <h4 className="text-lg font-semibold text-slate-800 dark:text-white mb-2 ">{section.title}</h4>
                      <p className="text-slate-600 dark:text-slate-300 text-base">{section.description}</p>
                    </div>
                    <div className="flex justify-center">
                      <img
                        src={section.imgSrc}
                        alt={section.title}
                        className="h-[350px] w-[350px] rounded-lg p-4 hover:scale-105 hover:border-primary"
                      />
                    </div>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
